// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-2jl","productName":"Table_productName__3AQe0"};